import { claimReasons, shipmentStatus } from '../../data/orders-data';

const customerOptions = [
  { value: 'customerTags', label: 'Customer Tags', type: 'stringList' },
  {
    value: 'customerOrderCount',
    label: 'Customer Order Count',
    type: 'number',
  },
  {
    value: 'customerStoreClaimCount',
    label: 'Customer Store Claim Count',
    type: 'number',
  },
];

const claimOptions = [
  { value: 'productCount', label: 'Claim Product Count', type: 'number' },
  { value: 'claimReason', label: 'Claim Reason', type: 'string' },
];

const productOptions = [
  { value: 'productTags', label: 'Product Tags', type: 'stringList' },
  { value: 'productCollections', label: 'Product Collections', type: 'string' },
  { value: 'productTitle', label: 'Product Title', type: 'string' },
  { value: 'productPrice', label: 'Product Price', type: 'number' },
  { value: 'productInventory', label: 'Product Inventory', type: 'number' },
];

const orderOptions = [
  { value: 'orderValue', label: 'Order Value', type: 'number' },
  { value: 'orderTags', label: 'Order Tags', type: 'stringList' },
  {
    value: 'orderShippingMethod',
    label: 'Order Shipping Methods',
    type: 'string',
  },
  { value: 'orderDiscount', label: 'Order Discount', type: 'number' },
  { value: 'orderCity', label: 'Order City', type: 'string' },
  { value: 'orderCountry', label: 'Order Country', type: 'string' },
  { value: 'orderZip', label: 'Order Zip', type: 'string' },
  {
    value: 'orderItemFulfillmentStatus',
    label: 'Order Fulfillment Status',
    type: 'string',
  },
  {
    value: 'orderTrackingStatus',
    label: 'Order Tracking Status',
    type: 'string',
  },
];

export const groupedExpressionFieldOptions = [
  {
    label: 'Customer',
    options: customerOptions,
  },
  {
    label: 'Claim',
    options: claimOptions,
  },
  {
    label: 'Product',
    options: productOptions,
  },
  {
    label: 'Order',
    options: orderOptions,
  },
];

export const allGroupedExpressionFieldOptions = groupedExpressionFieldOptions
  .map((o) => o.options)
  .flat(1);

export const operatorOptions = [
  { value: '_matchOneOf', label: 'Matches One Of', type: 'stringList' },
  { value: '_matchAll', label: 'Matches All', type: 'stringList' },
  { value: '_nMatchAll', label: 'Does Not Include', type: 'stringList' },

  { value: '_eq', label: 'Equals', type: 'number' },
  { value: '_oneOf', label: 'One Of', type: 'number' },
  { value: '_neq', label: 'Not Equals', type: 'number' },
  { value: '_nOneOf', label: 'Not One Of', type: 'number' },
  { value: '_gt', label: 'Higher Than', type: 'number' },
  { value: '_lt', label: 'Lower Than', type: 'number' },
  { value: '_gte', label: 'Equal Or Higher Than', type: 'number' },
  { value: '_lte', label: 'Equal Or Lower Than', type: 'number' },
  { value: '_eInterval', label: 'Exclusive Interval', type: 'number' },
  { value: '_iInterval', label: 'Inclusive interval', type: 'number' },

  { value: '_eq', label: 'Equals', type: 'string' },
  { value: '_oneOf', label: 'One Of', type: 'string' },
  { value: '_neq', label: 'Not Equals', type: 'string' },
  { value: '_nOneOf', label: 'Not One Of', type: 'string' },
  // { value: "_contains", label: "Contains", type: "string" },
];

export const ruleActionOptions = [
  { value: 'REORDER', label: 'REORDER' },
  { value: 'REFUND', label: 'REFUND' },
  { value: 'STORE_CREDIT', label: 'STORE CREDIT' },
  { value: 'GIFT_CARD', label: 'GIFT CARD' },
  { value: 'DISCOUNT_COUPON', label: 'DISCOUNT COUPON' },
  { value: 'OTHER', label: 'OTHER' },
  { value: 'DENY', label: 'DENY' },
  { value: 'PREFERRED_RESOLUTION', label: 'PREFERRED RESOLUTION' },
];

const inputFieldMapping = {
  customerTags: {
    _matchOneOf: {
      field: 'stringInput',
      placeHolder: 'Member,Prime,Agent',
    },
    _matchAll: {
      field: 'stringInput',
      placeHolder: 'Member,Prime,Agent',
    },
    _nMatchAll: {
      field: 'stringInput',
      placeHolder: 'External,WholeSale',
    },
  },
  customerOrderCount: {
    _eq: {
      field: 'numberInput',
      placeHolder: '10',
    },
    _oneOf: {
      field: 'stringInput',
      placeHolder: '10,20,30',
    },
    _neq: {
      field: 'numberInput',
      placeHolder: '10',
    },
    _nOneOf: {
      field: 'stringInput',
      placeHolder: '10,20,30',
    },
    _gt: {
      field: 'numberInput',
      placeHolder: '10',
    },
    _lt: {
      field: 'numberInput',
      placeHolder: '10',
    },
    _gte: {
      field: 'numberInput',
      placeHolder: '10',
    },
    _lte: {
      field: 'numberInput',
      placeHolder: '10',
    },
    _eInterval: {
      field: 'numberRangeInput',
      placeHolder: '10,50',
    },
    _iInterval: {
      field: 'numberRangeInput',
      placeHolder: '10,50',
    },
  },
  customerStoreClaimCount: {
    _eq: {
      field: 'numberInput',
      placeHolder: '10',
    },
    _oneOf: {
      field: 'stringInput',
      placeHolder: '10,20,30',
    },
    _neq: {
      field: 'numberInput',
      placeHolder: '10',
    },
    _nOneOf: {
      field: 'stringInput',
      placeHolder: '10,20,30',
    },
    _gt: {
      field: 'numberInput',
      placeHolder: '10',
    },
    _lt: {
      field: 'numberInput',
      placeHolder: '10',
    },
    _gte: {
      field: 'numberInput',
      placeHolder: '10',
    },
    _lte: {
      field: 'numberInput',
      placeHolder: '10',
    },
    _eInterval: {
      field: 'numberRangeInput',
      placeHolder: '10,50',
    },
    _iInterval: {
      field: 'numberRangeInput',
      placeHolder: '10,50',
    },
  },

  productCount: {
    _eq: {
      field: 'numberInput',
      placeHolder: '5',
    },
    _oneOf: {
      field: 'stringInput',
      placeHolder: '3,5,8',
    },
    _neq: {
      field: 'numberInput',
      placeHolder: '3',
    },
    _nOneOf: {
      field: 'stringInput',
      placeHolder: '3,5,8',
    },
    _gt: {
      field: 'numberInput',
      placeHolder: '5',
    },
    _lt: {
      field: 'numberInput',
      placeHolder: '5',
    },
    _gte: {
      field: 'numberInput',
      placeHolder: '5',
    },
    _lte: {
      field: 'numberInput',
      placeHolder: '5',
    },
    _eInterval: {
      field: 'numberRangeInput',
      placeHolder: '1,5',
    },
    _iInterval: {
      field: 'numberRangeInput',
      placeHolder: '1,5',
    },
  },

  productTags: {
    _matchOneOf: {
      field: 'stringInput',
      placeHolder: 'Premium,Exclusive,Sale',
    },
    _matchAll: {
      field: 'stringInput',
      placeHolder: 'Premium,Exclusive,Sale',
    },
    _nMatchAll: {
      field: 'stringInput',
      placeHolder: 'Premium,Exclusive,Sale',
    },
  },
  productCollections: {
    _eq: {
      field: 'stringInput',
      placeHolder: 'Adjustable Chain',
    },
    _oneOf: {
      field: 'stringInput',
      placeHolder: 'Adjustable Chain,Raw Juice,Glue Box',
    },
    _neq: {
      field: 'stringInput',
      placeHolder: 'Adjustable Chain',
    },
    _nOneOf: {
      field: 'stringInput',
      placeHolder: 'Adjustable Chain,Raw Juice,Glue Box',
    },
  },
  productTitle: {
    _eq: {
      field: 'stringInput',
      placeHolder: 'Adjustable Chain',
    },
    _oneOf: {
      field: 'stringInput',
      placeHolder: 'Adjustable Chain,Raw Juice,Glue Box',
    },
    _neq: {
      field: 'stringInput',
      placeHolder: 'Adjustable Chain',
    },
    _nOneOf: {
      field: 'stringInput',
      placeHolder: 'Adjustable Chain,Raw Juice,Glue Box',
    },
  },
  productPrice: {
    _eq: {
      field: 'numberInput',
      placeHolder: '99',
    },
    _oneOf: {
      field: 'stringInput',
      placeHolder: '49,99,199',
    },
    _neq: {
      field: 'numberInput',
      placeHolder: '99',
    },
    _nOneOf: {
      field: 'stringInput',
      placeHolder: '49,99,199',
    },
    _gt: {
      field: 'numberInput',
      placeHolder: '99',
    },
    _lt: {
      field: 'numberInput',
      placeHolder: '99',
    },
    _gte: {
      field: 'numberInput',
      placeHolder: '99',
    },
    _lte: {
      field: 'numberInput',
      placeHolder: '99',
    },
    _eInterval: {
      field: 'numberRangeInput',
      placeHolder: '99,199',
    },
    _iInterval: {
      field: 'numberRangeInput',
      placeHolder: '99,199',
    },
  },
  productInventory: {
    _eq: {
      field: 'numberInput',
      placeHolder: '10',
    },
    _oneOf: {
      field: 'stringInput',
      placeHolder: '0,5,10',
    },
    _neq: {
      field: 'numberInput',
      placeHolder: '10',
    },
    _nOneOf: {
      field: 'stringInput',
      placeHolder: '0,5,10',
    },
    _gt: {
      field: 'numberInput',
      placeHolder: '0',
    },
    _lt: {
      field: 'numberInput',
      placeHolder: '5',
    },
    _gte: {
      field: 'numberInput',
      placeHolder: '1',
    },
    _lte: {
      field: 'numberInput',
      placeHolder: '0',
    },
    _eInterval: {
      field: 'numberRangeInput',
      placeHolder: '1,10',
    },
    _iInterval: {
      field: 'numberRangeInput',
      placeHolder: '0,5',
    },
  },

  orderValue: {
    _eq: {
      field: 'numberInput',
      placeHolder: '99',
    },
    _oneOf: {
      field: 'stringInput',
      placeHolder: '49,99,199',
    },
    _neq: {
      field: 'numberInput',
      placeHolder: '99',
    },
    _nOneOf: {
      field: 'stringInput',
      placeHolder: '49,99,199',
    },
    _gt: {
      field: 'numberInput',
      placeHolder: '99',
    },
    _lt: {
      field: 'numberInput',
      placeHolder: '99',
    },
    _gte: {
      field: 'numberInput',
      placeHolder: '99',
    },
    _lte: {
      field: 'numberInput',
      placeHolder: '99',
    },
    _eInterval: {
      field: 'numberRangeInput',
      placeHolder: '99,199',
    },
    _iInterval: {
      field: 'numberRangeInput',
      placeHolder: '99,199',
    },
  },
  orderTags: {
    _matchOneOf: {
      field: 'stringInput',
      placeHolder: 'Express,Sale,Discounted',
    },
    _matchAll: {
      field: 'stringInput',
      placeHolder: 'Express,Sale,Discounted',
    },
    _nMatchAll: {
      field: 'stringInput',
      placeHolder: 'Express,Sale,Discounted',
    },
  },
  orderShippingMethod: {
    _eq: {
      field: 'stringInput',
      placeHolder: 'UPS - Next Day Air',
    },
    _oneOf: {
      field: 'stringInput',
      placeHolder: 'UPS - Next Day Air,FedEx - Ground',
    },
    _neq: {
      field: 'stringInput',
      placeHolder: 'UPS - Next Day Air',
    },
    _nOneOf: {
      field: 'stringInput',
      placeHolder: 'UPS - Next Day Air,FedEx - Ground',
    },
  },
  orderDiscount: {
    _eq: {
      field: 'numberInput',
      placeHolder: '99',
    },
    _oneOf: {
      field: 'stringInput',
      placeHolder: '49,99,199',
    },
    _neq: {
      field: 'numberInput',
      placeHolder: '99',
    },
    _nOneOf: {
      field: 'stringInput',
      placeHolder: '49,99,199',
    },
    _gt: {
      field: 'numberInput',
      placeHolder: '99',
    },
    _lt: {
      field: 'numberInput',
      placeHolder: '99',
    },
    _gte: {
      field: 'numberInput',
      placeHolder: '99',
    },
    _lte: {
      field: 'numberInput',
      placeHolder: '99',
    },
    _eInterval: {
      field: 'numberRangeInput',
      placeHolder: '99,199',
    },
    _iInterval: {
      field: 'numberRangeInput',
      placeHolder: '99,199',
    },
  },
  orderCity: {
    _eq: {
      field: 'stringInput',
      placeHolder: 'New York',
    },
    _oneOf: {
      field: 'stringInput',
      placeHolder: 'New York,Los Angeles',
    },
    _neq: {
      field: 'stringInput',
      placeHolder: 'New York',
    },
    _nOneOf: {
      field: 'stringInput',
      placeHolder: 'New York,Los Angeles',
    },
  },
  orderCountry: {
    _eq: {
      field: 'stringInput',
      placeHolder: 'USA',
    },
    _oneOf: {
      field: 'stringInput',
      placeHolder: 'USA,Canada',
    },
    _neq: {
      field: 'stringInput',
      placeHolder: 'USA',
    },
    _nOneOf: {
      field: 'stringInput',
      placeHolder: 'USA,Canada',
    },
  },
  orderZip: {
    _eq: {
      field: 'stringInput',
      placeHolder: '90001',
    },
    _oneOf: {
      field: 'stringInput',
      placeHolder: '10001,90001',
    },
    _neq: {
      field: 'stringInput',
      placeHolder: '10001',
    },
    _nOneOf: {
      field: 'stringInput',
      placeHolder: '10001,90001',
    },
  },
  orderItemFulfillmentStatus: {
    _eq: {
      field: 'stringInput',
      placeHolder: 'Fulfilled',
    },
    _oneOf: {
      field: 'stringInput',
      placeHolder: 'Fulfilled,Unulfilled',
    },
    _neq: {
      field: 'stringInput',
      placeHolder: 'Fulfilled',
    },
    _nOneOf: {
      field: 'stringInput',
      placeHolder: 'Fulfilled,Unulfilled',
    },
  },
  orderTrackingStatus: {
    _eq: {
      field: 'stringDropDown',
      placeHolder: 'Tracking Status',
    },
    _oneOf: {
      field: 'stringDropDown',
      placeHolder: 'Tracking Status',
    },
    _neq: {
      field: 'stringDropDown',
      placeHolder: 'Tracking Status',
    },
    _nOneOf: {
      field: 'stringDropDown',
      placeHolder: 'Tracking Status',
    },
  },
  claimReason: {
    _eq: {
      field: 'stringDropDown',
      placeHolder: 'Claim Reason',
    },
    _oneOf: {
      field: 'stringDropDown',
      placeHolder: 'Claim Reason',
    },
    _neq: {
      field: 'stringDropDown',
      placeHolder: 'Claim Reason',
    },
    _nOneOf: {
      field: 'stringDropDown',
      placeHolder: 'Claim Reason',
    },
  },
};

const singleValueOperator = ['_eq', '_neq', '_gt', '_lt', '_gte', '_lte'];
const arrayValueOperators = [
  '_matchOneOf',
  '_matchAll',
  '_nMatchAll',
  '_oneOf',
  '_nOneOf',
];
const rangeValueOperators = ['_eInterval', '_iInterval'];

export const getStatementInputConfig = (field, expression) => {
  const config = inputFieldMapping[field]
    ? inputFieldMapping[field][expression]
    : null;
  if (config) return config;
  return {
    field: 'stringInput',
    placeHolder: 'Value',
  };
};

export const getDrownDownOptionByFieldName = (field) => {
  switch (field) {
    case 'orderTrackingStatus':
      return shipmentStatus;
    case 'claimReason':
      return claimReasons;
    default:
      return [];
  }
};

export const validateAndUpdateRule = (rule) => {
  const messages = [];
  const statements = [];
  if (!rule || typeof rule !== 'object') {
    return {
      hasError: true,
      messages: ['Rule is required'],
      statements: [],
    };
  }
  if (
    !rule.title ||
    typeof rule.title !== 'string' ||
    rule.title.trim() === ''
  ) {
    messages.push('Rule Name is required');
  }
  if (
    !rule.action ||
    typeof rule.action !== 'string' ||
    rule.action.trim() === ''
  ) {
    messages.push('Rule Action is required');
  }
  const ruleStatements = Array.isArray(rule.statements) ? rule.statements : [];
  if (!Array.isArray(rule.statements) || !rule.statements.length) {
    messages.push('At least one condition is required');
  }
  ruleStatements.forEach((statement, ind) => {
    if (!statement || typeof statement !== 'object') {
      messages.push(`Condition ${ind + 1}: Invalid condition definition`);
      return;
    }
    if (
      !statement.expressionField ||
      typeof statement.expressionField !== 'string' ||
      statement.expressionField.trim() === ''
    )
      messages.push(`Condition ${ind + 1}: Expression Field is required`);
    if (
      !statement.expression ||
      typeof statement.expression !== 'string' ||
      statement.expression.trim() === ''
    )
      messages.push(`Condition ${ind + 1}: Operator Field is required`);
    if (
      statement.expressionValue === undefined ||
      statement.expressionValue === null ||
      (typeof statement.expressionValue === 'string' &&
        statement.expressionValue.trim() === '')
    )
      messages.push(`Condition ${ind + 1}: Value Field is required`);
  });
  if (!messages.length) {
    ruleStatements.forEach((statement, ind) => {
      const expectedFieldType = getExpectedFieldTypeByOperation(
        statement.expressionField,
        statement.expression,
      );
      let transformedValue = statement.expressionValue;
      if (expectedFieldType === 'number') {
        const isNumeric =
          (typeof transformedValue === 'number' &&
            Number.isFinite(transformedValue)) ||
          (typeof transformedValue === 'string' &&
            transformedValue.trim() !== '' &&
            Number.isFinite(Number(transformedValue)));
        if (!isNumeric)
          messages.push(`Condition ${ind + 1}: Expected Value is number`);
        else transformedValue = Number(transformedValue);
      } else if (expectedFieldType === 'numberInterval') {
        const exp = String(statement.expressionValue || '').split(',');
        if (exp.length !== 2)
          messages.push(`Condition ${ind + 1}: Expected Number Range values`);
        else if (
          exp.some((v) => !v.trim() || !Number.isFinite(Number(v))) ||
          Number(exp[0]) > Number(exp[1])
        )
          messages.push(`Condition ${ind + 1}: Expected Number Values`);
        else if (exp.length === 2 && !isNaN(exp[0]) && !isNaN(exp[1]))
          transformedValue = [Number(exp[0]), Number(exp[1])];
      } else if (expectedFieldType === 'numberArray') {
        const exp = String(statement.expressionValue || '').split(',');
        const validateNumErr = exp.some(
          (v) => !v.trim() || !Number.isFinite(Number(v)),
        );
        if (validateNumErr)
          messages.push(`Condition ${ind + 1}: Expected Number Values`);
        else transformedValue = exp.map((v) => Number(v));
      } else if (
        expectedFieldType === 'stringList' ||
        expectedFieldType === 'stringArray'
      ) {
        if (Array.isArray(statement.expressionValue)) {
          transformedValue = statement.expressionValue
            .map((v) => (typeof v === 'string' ? v.trim() : String(v)))
            .filter((v) => v.length > 0);
        } else {
          const exp = String(statement.expressionValue || '').split(',');
          transformedValue = exp
            .map((v) => v.trim())
            .filter((v) => v.length > 0);
        }
      }
      if (Array.isArray(transformedValue) && transformedValue.length === 0) {
        messages.push(`Condition ${ind + 1}: Value Field is required`);
      }
      statements.push({
        ...statement,
        expressionValue: transformedValue,
        fieldType: expectedFieldType,
      });
    });
  }
  return {
    hasError: !!messages.length,
    messages,
    statements: messages.length ? [] : statements,
  };
};

const getExpectedFieldTypeByOperation = (field, operator) => {
  const fieldType = allGroupedExpressionFieldOptions.find(
    (f) => f.value === field,
  );
  if (!fieldType) return 'string';
  if (fieldType.type === 'number' && singleValueOperator.includes(operator))
    return 'number';
  else if (
    fieldType.type === 'number' &&
    rangeValueOperators.includes(operator)
  )
    return 'numberInterval';
  else if (
    fieldType.type === 'number' &&
    arrayValueOperators.includes(operator)
  )
    return 'numberArray';
  else if (fieldType.type === 'stringList') return 'stringArray';
  else if (
    fieldType.type === 'string' &&
    singleValueOperator.includes(operator)
  )
    return 'string';
  else if (
    fieldType.type === 'string' &&
    arrayValueOperators.includes(operator)
  )
    return 'stringArray';
  return 'string';
};

export const transformRuleStatementsToSave = (statements) => {
  const maxStatementIndex = statements.length - 1;
  const transformedStatements = statements.map((statement, ind) => {
    return {
      [statement.expressionField]: {
        fieldType: statement.fieldType,
        connector:
          ind === maxStatementIndex ? '' : statements[ind + 1].connector || '',
        expression: {
          [statement.expression]: statement.expressionValue,
        },
      },
    };
  });
  return transformedStatements;
};

export const getNewRuleTemplate = () => {
  return {
    id: null,
    title: '',
    active: true,
    action: '',
    notify: true,
    refundShipping: false,
    actionNotes: '',
    statements: [
      {
        expressionField: '',
        expression: '',
        expressionValue: '',
        connector: '',
        config: { field: 'stringInput', placeHolder: 'Value' },
      },
    ],
  };
};

export const operatorLabels = {
  _eq: 'equals',
  _neq: 'does not equal',
  _gt: 'is greater than',
  _lt: 'is less than',
  _gte: 'is at least',
  _lte: 'is at most',
  _oneOf: 'is one of',
  _nOneOf: 'is not one of',
  _matchOneOf: 'matches one of',
  _matchAll: 'matches all of',
  _nMatchAll: 'does not match any of',
  _eInterval: 'is between (exclusive)',
  _iInterval: 'is between',
};

export const actionDisplayNames = {
  REFUND: 'Auto-Refund',
  REORDER: 'Auto-Reorder / Replacement',
  STORE_CREDIT: 'Issue Store Credit',
  DENY: 'Auto-Deny Claim',
  PREFERRED_RESOLUTION: 'Honor Customer Preferred Resolution',
  GIFT_CARD: 'Issue Gift Card',
  DISCOUNT_COUPON: 'Issue Discount Coupon',
  OTHER: 'Custom Resolution',
};

export const getFieldCategory = (fieldValue) => {
  for (const group of groupedExpressionFieldOptions) {
    if (group.options.some((opt) => opt.value === fieldValue)) {
      switch (group.label) {
        case 'Customer':
          return {
            label: 'Customer',
            color: 'bg-blue-50 text-blue-700 border-blue-200',
          };
        case 'Claim':
          return {
            label: 'Claim',
            color: 'bg-amber-50 text-amber-700 border-amber-200',
          };
        case 'Product':
          return {
            label: 'Product',
            color: 'bg-purple-50 text-purple-700 border-purple-200',
          };
        case 'Order':
          return {
            label: 'Order',
            color: 'bg-indigo-50 text-indigo-700 border-indigo-200',
          };
        default:
          return {
            label: group.label,
            color: 'bg-gray-50 text-gray-700 border-gray-200',
          };
      }
    }
  }
  return {
    label: 'Condition',
    color: 'bg-gray-50 text-gray-700 border-gray-200',
  };
};

export const getRuleNaturalLanguageSummary = (rule) => {
  if (!rule) return '';
  const actionText =
    actionDisplayNames[rule.action] || rule.action || 'take action';
  const statements = rule.statements || [];

  if (!statements.length) {
    return `When a claim is filed, ${actionText}.`;
  }

  const conditionStrings = statements.map((statement, idx) => {
    const fieldObj = allGroupedExpressionFieldOptions.find(
      (opt) => opt.value === statement.expressionField,
    );
    const fieldLabel = fieldObj
      ? fieldObj.label
      : statement.expressionField || 'Field';
    const opLabel =
      operatorLabels[statement.expression] || statement.expression || 'matches';

    let valStr = statement.expressionValue;
    const isCurrencyField = [
      'orderValue',
      'productPrice',
      'orderDiscount',
    ].includes(statement.expressionField);

    if (Array.isArray(valStr)) {
      valStr = valStr.map((v) => `"${v}"`).join(', ');
    } else if (
      isCurrencyField &&
      typeof valStr === 'number' &&
      Number.isFinite(valStr)
    ) {
      valStr = `$${valStr.toFixed(2)}`;
    } else if (
      isCurrencyField &&
      typeof valStr === 'string' &&
      valStr.trim() !== '' &&
      !valStr.includes(',') &&
      Number.isFinite(Number(valStr))
    ) {
      valStr = `$${Number(valStr).toFixed(2)}`;
    } else if (typeof valStr === 'number') {
      valStr = String(valStr);
    } else if (valStr !== undefined && valStr !== null && valStr !== '') {
      valStr = `"${valStr}"`;
    } else {
      valStr = 'any value';
    }

    const prefix = idx === 0 ? 'IF' : statement.connector || 'AND';
    return `${prefix} ${fieldLabel} ${opLabel} ${valStr}`;
  });

  let resolutionDetails = '';
  if (rule.action === 'REFUND') {
    resolutionDetails = rule.refundShipping ? ' (including shipping)' : '';
  }

  return `${conditionStrings.join(
    ' ',
  )} THEN ${actionText}${resolutionDetails}.`;
};

export const getPrebuiltTemplates = () => {
  return [
    {
      id: 'template-low-value-refund',
      title: 'Auto-Refund Low-Value Lost Packages',
      description: 'Refund lost-package claims for orders at or below $25.',
      action: 'REFUND',
      refundShipping: true,
      notify: true,
      actionNotes: 'Auto-approved: order total under $25 and reported lost',
      active: true,
      statements: [
        {
          expressionField: 'claimReason',
          expression: '_eq',
          expressionValue: 'LOST',
          connector: '',
          config: { field: 'stringDropDown', placeHolder: 'Claim Reason' },
        },
        {
          expressionField: 'orderValue',
          expression: '_lte',
          expressionValue: 25,
          connector: 'AND',
          config: { field: 'numberInput', placeHolder: '25' },
        },
      ],
    },
    {
      id: 'template-damaged-reorder',
      title: 'Auto-Reship Damaged Products at or Below $75',
      description:
        'Automatically replace damaged items for orders at or below $75.',
      action: 'REORDER',
      refundShipping: false,
      notify: true,
      actionNotes: 'Auto-reordered: customer reported damaged product',
      active: true,
      statements: [
        {
          expressionField: 'claimReason',
          expression: '_eq',
          expressionValue: 'DAMAGED',
          connector: '',
          config: { field: 'stringDropDown', placeHolder: 'Claim Reason' },
        },
        {
          expressionField: 'orderValue',
          expression: '_lte',
          expressionValue: 75,
          connector: 'AND',
          config: { field: 'numberInput', placeHolder: '75' },
        },
      ],
    },
    {
      id: 'template-vip-store-credit',
      title: 'VIP Customer Instant Store Credit',
      description:
        'Delight top customers with immediate store credit when they submit any claim.',
      action: 'STORE_CREDIT',
      refundShipping: false,
      notify: true,
      actionNotes: 'VIP customer fast-pass: immediate store credit issued',
      active: true,
      statements: [
        {
          expressionField: 'customerTags',
          expression: '_matchOneOf',
          expressionValue: 'VIP, VIP Customer, Loyal',
          connector: '',
          config: { field: 'stringInput', placeHolder: 'VIP, VIP Customer' },
        },
      ],
    },
  ];
};
